import { useMemo } from "react";
import { useTheme } from "@mui/material";
import { MyLeaveBarItemProps } from "my-leave/components";
import { formatLeaveDays } from "my-leave/utils/format-leave-days";

export interface useMyLeaveBarNewProps {
  fulfilled: number;
  requested: number;
  requestable: number;
}

export const useMyLeaveBarNew = ({
  fulfilled,
  requestable,
  requested,
}: useMyLeaveBarNewProps) => {
  const theme = useTheme();

  const barItems: MyLeaveBarItemProps[] = useMemo(() => {
    const allDays = requestable + requested + fulfilled;
    const returnList: MyLeaveBarItemProps[] = [];

    if (requestable > 0)
      returnList.push({
        color: theme.palette.greenBase.main,
        label: "MY_LEAVE_REQUESTABLE",
        percent: (requestable / allDays) * 100,
        value: formatLeaveDays(requestable),
      });

    if (requested > 0)
      returnList.push({
        color: theme.palette.yellowBase.main,
        label: "MY_LEAVE_REQUESTED",
        percent: (requested / allDays) * 100,
        value: formatLeaveDays(requested),
      });

    if (fulfilled > 0)
      returnList.push({
        color: theme.palette.primary.main,
        label: "MY_LEAVE_FULFILLED",
        percent: (fulfilled / allDays) * 100,
        value: formatLeaveDays(fulfilled),
      });

    return returnList;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestable, requested, fulfilled]);

  return {
    barItems,
  };
};
